import React from 'react';
import { buildStatus } from '../data/buildStatus';

const card = { background: '#ffffff', border: '1px solid #d8c9a8', borderRadius: 8, padding: '1.25rem 1.5rem', marginBottom: '1.25rem' };
const heading = { margin: '0 0 0.75rem', color: '#1a1a1a', fontSize: '1.05rem', letterSpacing: '0.02em' };
const item = { margin: '0 0 0.5rem', color: '#333', lineHeight: 1.5 };

function Section({ title, items, color }) {
  return (
    <div style={card}>
      <h2 style={{ ...heading, borderLeft: `4px solid ${color}`, paddingLeft: 10 }}>{title}</h2>
      <ul style={{ margin: 0, paddingLeft: '1.25rem' }}>
        {items.map((text, i) => <li key={i} style={item}>{text}</li>)}
      </ul>
    </div>
  );
}

export default function BuildStatus() {
  return (
    <div style={{ minHeight: '100vh', background: '#faf8f3', padding: '2rem 16px' }}>
      <div style={{ maxWidth: 820, margin: '0 auto' }}>
        <h1 style={{ margin: '0 0 0.25rem', color: '#1a1a1a' }}>Resi Build Status</h1>
        <p style={{ margin: '0 0 1.5rem', color: '#7f7f7f' }}>As of {buildStatus.asOf}</p>
        <Section title="Done" items={buildStatus.done} color="#3d6b4f" />
        <Section title="In progress" items={buildStatus.inProgress} color="#D4AF37" />
        <Section title="Requested" items={buildStatus.requested} color="#8C6D1F" />
        <Section title="Pending" items={buildStatus.pending} color="#7f7f7f" />
      </div>
    </div>
  );
}
